import React, { useEffect } from 'react';

import { useSharedData } from '../Contexts/SharedContext';
import { useTheme } from '../Contexts/ThemeContext';
import { useLanguage } from '../Contexts/LanguageContext';

import { getTranslatedValue } from '../Utils/getTranslatedText';

import PageHeader from '../Components/PageHeader';
import Header from '../Components/Header/Header';
import Footer from '../Components/Footer/Footer';
import ExhibitionTeaser from '../Components/ExhibitionTeaser';

import strings from '../strings';

const GuidesPage = () => {
    const { content, loading, error } = useSharedData();
    const { setTheme} = useTheme();
    const { language } = useLanguage();
    
    useEffect(() => {
        setTheme('');
    }, [setTheme]);

    const teasers = content?.guideTeasers?.items || [];

    return (
        <>
            <Header withBackNavigation navigationSlug="/" />
                <div className="guides-page">
                    <PageHeader title={strings.GUIDES_PAGE_TITLE[language]} />

                    { teasers.map((teaser, idx) => (
                        <ExhibitionTeaser 
                            key={ idx }
                            image={ teaser.image || null }
                            text={getTranslatedValue(teaser.title, language)} 
                            labels={ teaser.labels?.items ?? []}
                            targetUrl={ resolveTargetUrl(teaser) }
                            themeClass={teaser.theme ?? 'default'}
                        />
                    ))}
                </div>
            <Footer />
        </>

    );
}

export default GuidesPage;

function resolveTargetUrl(teaser) {
    if (!teaser.slug) {
        console.warn('Teaser slug missing');
        return null;
    }

    const base = '/guide/';

    return `${base}${teaser.slug}`;
}